<svg class="icon-context" [class.active]="isActive" xmlns="http://www.w3.org/2000/svg" width="16" height="16"
    viewBox="0 0 16 16" fill="none">
    <circle cx="8" cy="8" r="6.5" stroke="var(--text-color-dark)" />
    <path d="M7.5 4V8.5L10 10.5" stroke="var(--text-color-dark)" stroke-linecap="round" stroke-linejoin="round" />
</svg>
